// extracted by mini-css-extract-plugin
module.exports = {"img":"landingPage_img__ZTMQa","start":"landingPage_start__Z691H"};